import { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest, getMsalInstance } from './msalConfig';
import { setCookieTokenRoute } from '@common/constants';

export const getTokenLocalStorage = () => {
  return localStorage?.getItem('msal-token') ?? null;
};

export const setTokenLocalStorage = (value: string) => {
  localStorage?.setItem('msal-token', value);
};

export const getCachedToken = () => {
  const token = getTokenLocalStorage();
  if (token === null || token === undefined) {
    acquireToken(getMsalInstance()).then((updateToken) => {
      return updateToken;
    });
  } else {
    return token;
  }
};

export const acquireToken = async (msalInstance: IPublicClientApplication = null) => {
  try {
    if (msalInstance === null) {
      throw Error('MSAL Instance not found.');
    }

    const account = msalInstance?.getActiveAccount() ?? null;
    if (!account) {
      console.info('No active account! Verify a user has been signed in and setActiveAccount has been called.');
      return;
    }

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    const accessToken = response?.accessToken;

    await fetch(setCookieTokenRoute, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ accessToken, email: response?.account?.username }),
    });
    setTokenLocalStorage(response?.accessToken);
    return response?.accessToken;
  } catch (error) {
    console.error(`Acquire token error - ${error}`);
  }
};
